// main components
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// mui components
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  Box,
  InputAdornment,
  IconButton,
  OutlinedInput
} from '@mui/material'
import { Button } from 'antd'
import GlobalChip from '../form/Chip'
import { useSelector } from 'react-redux'
import { UpdateAccountInfo } from '../accountSettings/UpdateAccountInfo'
import { userHasAuthorization } from '../../services/AuthService'

// styles
import { usersCardStyles } from '../../styles/classes/CompanySettingsClasses'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons'
import { formatPhoneNumber } from '../../lib/Global'

export const UsersCard = props => {
  const { roles, users } = props
  const { classes } = usersCardStyles()
  const { t } = useTranslation()
  const userStore = useSelector(state => state.auth.user)
  let filterUser = users

  const [roleOptions, setRoleOptions] = useState(null)
  const [query, setQuery] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const [panelEvent, setPanelEvent] = useState(null)
  const [openPanel, setOpenPanel] = useState(false)

  useEffect(() => {
    if (!roles || roles.length === 0) return

    const updatedRoles = {}
    roles.forEach(item => {
      updatedRoles[item.id] = item.name
    })
    setRoleOptions(updatedRoles)
  }, [roles])

  const handleNewPanel = () => {
    setSelectedUser({
      firstName: null,
      lastName: null,
      photo_url: null,
      roles: null,
      username: null
    })
    setErrorMessage(null)
    setPanelEvent('new')
    setOpenPanel(true)
  }

  const handleEditPanel = obj => {
    setSelectedUser(obj)
    setErrorMessage(null)
    setPanelEvent('edit')
    setOpenPanel(true)
  }

  const EditButton = props => {
    const { classes } = usersCardStyles()
    if (!userHasAuthorization('users:write')) return
    return (
      <Button
        data-testid={'add_user_button'}
        className={classes.editButton}
        onClick={props.onClick}
      >
        {props.label}
      </Button>
    )
  }

  // function for search input
  function handleFilterChange (e) {
    const value = e.target.value
    setQuery(value)
  }

  if (query !== '') {
    filterUser = users.filter(user =>
      (user.firstName + ' ' + user.lastName)
        .toLowerCase()
        .includes(query.toLowerCase())
    )
  }

  const adaptRoleName = role => {
    if (role) {
      const separated = role.split('_')
      const finalRole = []
      separated.forEach(word => {
        finalRole.push(word.charAt(0).toUpperCase() + word.slice(1))
      })
      return finalRole.join(' ')
    } else {
      return ''
    }
  }
  return (
    <Card className={classes.card} data-testid={'users_card'}>
      <CardActions disableSpacing classes={{ root: classes.actions }}>
        <Box className={classes.boxContainer}>
          <Box sx={{ flex: 0.3 }}>
            <Typography classes={{ root: classes.cardTitle }}>
              {props.cardtitle}
            </Typography>
          </Box>
          <Box className={classes.search}>
            <OutlinedInput
              className={classes.outlinedInput}
              size="small"
              value={query}
              placeholder={t('company_settings.users_card.search')}
              onChange={handleFilterChange}
              inputProps={{
                className: classes.searchText
              }}
              endAdornment={
                <InputAdornment position="end">
                  {query?.length > 0 && (
                    <IconButton
                      onClick={() => {
                        setQuery('')
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCircleXmark}
                        size="xs"
                        color="grey"
                        className={classes.clearIcon}
                      />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
          </Box>
          {/* TODO HANDLE ONLY ADMIN CAN PERFORM THIS */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              marginTop: '10px'
            }}
          >
            <EditButton
              label={t('company_settings.buttons.add')}
              onClick={handleNewPanel}
            />
          </Box>
        </Box>
      </CardActions>
      <CardContent classes={{ root: classes.content }}>
        <Box
          display="flex"
          flexDirection="column"
          className={classes.usersList}
        >
          {filterUser?.map((user, index) => (
            <div
              key={user.lastName + '_' + index}
              className={classes.itemDivider}
            >
              <Box
                display="flex"
                flexDirection="column"
                onClick={() => handleEditPanel(user)}
                className={classes.lineItem}
              >
                <Typography classes={{ root: classes.userItem }}>
                  {user.firstName} {user.lastName}
                </Typography>
                <GlobalChip
                  chips={[
                    user.email,
                    formatPhoneNumber(user.phone),
                    adaptRoleName(user.role),
                    roleOptions && user.roles && user.roles !== 'no_value'
                      ? roleOptions[user.roles]
                      : t('company_settings.mobile_only')
                  ].filter(
                    item => typeof item !== 'undefined' && item !== '' && item
                  )}
                  selected={new Set()}
                  setSelected={() => {}}
                  skipTranslate={true}
                />
              </Box>
              {index !== filterUser?.length - 1 && (
                <div className={classes.separator} />
              )}
            </div>
          ))}
        </Box>
      </CardContent>
      {selectedUser && (
        <UpdateAccountInfo
          affiliateId={props?.company?.affiliate_id}
          errorMessage={errorMessage}
          editDrawer={openPanel}
          handleClosePanel={() => {
            setOpenPanel(false)
            setSelectedUser(null)
          }}
          accountInfo={{ ...userStore, userInfo: selectedUser }}
          updateUsers={props.updateUsers}
          event={panelEvent}
          roles={roles}
          roleOptions={roleOptions}
          accountOwner={selectedUser.id === userStore.userInfo.id}
          mobile={props.mobile}
          setReloadUsers={props.setReloadUsers}
        />
      )}
    </Card>
  )
}
